import { useEffect } from "react";

export default function useScrollToHash(
  hash: string,
  offsetTop: number = 0,
  options?: ScrollToOptions
) {
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          // Scroll from main because body may have a `overflow: hidden`
          const containerRef = document.getElementById("main") || document.body;
          containerRef.scroll({
            top: element.offsetTop + offsetTop,
            ...options,
          });
        }
      }, 0);
    }
  }, [hash, offsetTop, options]);
}
